<template>
  <div class="progress-steps">
    <template v-for="(step, index) in steps">
      <div 
        :key="`step-${index}`"
        class="progress-step"
        :class="{ active: index <= currentStep, completed: index < currentStep }"
      >
        <div class="step-text">{{ step }}</div>
        <div class="step-number"></div>
      </div>
      <div 
        v-if="index < steps.length - 1" 
        :key="`line-${index}`"
        class="progress-line"
        :class="{ active: index < currentStep }"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProgressSteps',
  props: {
    steps: {
      type: Array,
      required: true,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-steps {
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: center;
  margin-bottom: 40px;
  padding: 0 20px;

  .progress-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .step-text {
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      font-weight: 400;
      transition: all 0.3s;
      margin-bottom: 12px;
      text-align: center;
    }
    
    .step-number {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: #ddd;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      font-size: 12px;
    }

    &.active {
      .step-number {
        background: #FFD500;
      }
      .step-text {
        font-family: DiDiSans-Pro-Bold;
        font-size: 28px;
        font-weight: 700;
      }
    }

    &.completed {
      .step-number {
        background: #FFD500;
      }
      .step-text {
        font-family: DiDiSans-Pro-Bold;
        font-size: 28px;
        font-weight: 700;
      }
    }
  }

  .progress-line {
    width: 96px;
    height: 8px;
    background: #FFD500;
    border-radius: 4px;
    margin: 0 8px 8px;
    transition: all 0.3s;
  }
}
</style> 